import React from "react";
import styled from "styled-components";

import { media } from "utils/style";

import Modal from "common-components/Modal/Modal";
import Button from "common-components/Buttons";

const InactivityModal = ({
  isInactivityModalOpen,
  logoutTimer,
  renewSession,
  section_title,
  section_description,
  buttonContent,
  ...rest
}) => {
  return (
    <Modal showTimeoutModal={isInactivityModalOpen} hideCloseButton contentLabel="inactivity modal">
      <Div>
        <H2>{section_title}</H2>
        <p>
          {section_description}
          <Span role="timer" aria-live="polite" aria-atomic="true">
            {Math.floor(logoutTimer / 60) +
              ":" +
              (logoutTimer % 60 < 10 ? "0" + (logoutTimer % 60) : logoutTimer % 60)}
          </Span>
        </p>
        <Button  onClick={renewSession}>{buttonContent}</Button>
      </Div>
    </Modal>
  );
};

export default InactivityModal;

const Div = styled.div`
  text-align: center;
  padding: 30px 75px;

  button {
  dispaly: block;
  margin: 0 auto;
  }
  ${media.mobile`
    padding: 0;
  `}
`;

const H2 = styled.h2`
  font-size: 24px;
  line-height: 26px;
  margin-bottom: 18px;
`;

const Span = styled.span`
  display: block;
  font-family: "Verizon-NHG-eDS", Helvetica, Arial, sans-serif;
  font-weight: 700;
  margin: 18px 0;
  font-size: 16px;
`;
